<div class="nk-content nk-content-fluid">
    <div class="container-xl wide-xl">
        <div class="nk-content-inner">
            <app-back [visivel]="isVisivel"></app-back>
            <div class="nk-content-body">
                <div class="nk-block-head nk-block-head-sm">
                    <div class="nk-block-between">
                        <div class="nk-block-head-content">
                            <h3 class="nk-block-title page-title">Offline</h3>
                            <div class="nk-block-des text-soft">
                                <p>Formularios Offline e Sincronizados</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nk-block">
                    <div class="card card-bordered">
                        <div class="card-aside-wrap">
                            <div class="card-inner card-inner-lg">
                                <ul class="nav nav-tabs">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-bs-toggle="tab" href="#tabItem1">
                                            <em class="icon ni ni-download"></em><span>Formularios Offline</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-bs-toggle="tab" href="#tabItem2">
                                            <em class="icon ni ni-activity-alt"></em><span>Formularios
                                                Sincronizados</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-bs-toggle="tab" href="#tabItem3">
                                            <em class="icon ni ni-tablet"></em><span>
                                                Completo do Tablet</span>
                                        </a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div class="tab-pane active" id="tabItem1">
                                        <div class="card-inner card-inner-lg">
                                            <div class="nk-block-head nk-block-head-lg">
                                                <div class="nk-block-between">
                                                    <div class="nk-block-head-content">
                                                        <h4 class="nk-block-title">Formularios Offline</h4>
                                                        <div class="nk-block-des">
                                                            <p>Histórico de formularios offline realizado até o presente
                                                                momento.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="nk-block card card-bordered">
                                                <table class="table table-ulogs">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th class="tb-col-time">
                                                                <span class="overline-title">ID</span>
                                                            </th>
                                                            <th class="tb-col-time">
                                                                <span class="overline-title">Data Criação</span>
                                                            </th>
                                                            <th class="tb-col-time">
                                                                <span class="overline-title">Ver</span>
                                                            </th>
                                                            <th class="tb-col-time">
                                                                <span class="overline-title">Remover</span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let item of mdcList | paginate: { id: 'offline-pagination', itemsPerPage: itemsPerPage, currentPage: p }; let i = index">
                                                            <td class="tb-col-time"><span class="sub-text">MdC_{{
                                                                    item.id }}</span></td>
                                                            <td class="tb-col-time">
                                                                <span class="sub-text">
                                                                    {{ item.data | date: 'dd-MM-yyyy HH:mm' }}
                                                                </span>
                                                            </td>

                                                            <td class="tb-col-time">
                                                                <a class="pointer" (click)="verDetalhesJson(item.id)">
                                                                    <em class="icon ni ni-eye-fill"></em>
                                                                </a>
                                                            </td>

                                                            <td class="tb-col-time">
                                                                <a class="pointer" (click)="confirmarRemocao(item.id)">
                                                                    <em class="icon ni ni-cross-fill-c"></em>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="mdcList.length === 0">
                                                            <td class="tb-col" colspan="4">
                                                                <p class="center">Sem dados no momento</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <pagination-controls id="offline-pagination" class="mt-3 pagination"
                                                    [previousLabel]="''" [nextLabel]="''" [responsive]="true"
                                                    (pageChange)="p = $event" [autoHide]="false"></pagination-controls>
                                            </div>
                                            <div *ngIf="mdcList.length > 0"
                                                class="between-center flex-wrap flex-md-nowrap g-3 mt-3">
                                                <div class="nk-block-text">
                                                </div>
                                                <button [disabled]="isSyncing" (click)="onSync()" type="button"
                                                    class="btn btn-success">
                                                    <span *ngIf="!isSyncing">Submeter todos</span>
                                                    <span *ngIf="isSyncing">
                                                        Sincronizando...
                                                        <em class="spinner-border spinner-border-sm" role="status"
                                                            aria-hidden="true"></em>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="tabItem2">
                                        <div class="card-inner card-inner-lg">
                                            <div class="nk-block-head nk-block-head-lg">
                                                <div class="nk-block-between">
                                                    <div class="nk-block-head-content">
                                                        <h4 class="nk-block-title">Formularios Sincronizados</h4>
                                                        <div class="nk-block-des">
                                                            <p>Histórico de atividade de trabalho realizado até o
                                                                presente momento.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="nk-block card card-bordered">
                                                <table class="table table-ulogs">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th class="tb-col-time">
                                                                <span class="overline-title">ID</span>
                                                            </th>
                                                            <th class="tb-col-time">
                                                                <span class="overline-title">DataCriação</span>
                                                            </th>
                                                            <th class="tb-col-ip">
                                                                <span class="overline-title">Utilizador</span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let item of userAtividadeService.userAtividade | paginate: { id: 'synced-pagination', itemsPerPage: itemsPerPage2, currentPage: p2 }; let i = index">
                                                            <td class="tb-col-time">
                                                                <span class="sub-text">MdC_{{item.mdcId}}</span>
                                                            </td>
                                                            <td class="tb-col-time">
                                                                <span class="sub-text">
                                                                    {{ item.createdDate | date: 'dd-MM-yyyy HH:mm' }}
                                                                </span>
                                                            </td>
                                                            <td class="tb-col-os">{{ item.userName }}</td>
                                                        </tr>
                                                        <tr *ngIf="userAtividadeService.userAtividade.length === 0">
                                                            <td class="tb-col" colspan="4">
                                                                <p class="center">Sem dados no momento</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr class="table-light">
                                                            <th class="tb-col-os">
                                                                <span class="overline-title">Total:</span>
                                                            </th>
                                                            <th class="tb-col-time" colspan="2">
                                                                <span class="overline-title">
                                                                    {{userAtividadeService.userAtividade.length}}
                                                                </span>
                                                            </th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                                <pagination-controls id="synced-pagination" class="mt-3 pagination"
                                                    [previousLabel]="''" [nextLabel]="''" [responsive]="true"
                                                    (pageChange)="p2 = $event" [autoHide]="true"></pagination-controls>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="tabItem3">
                                        <div class="card-inner card-inner-lg">
                                            <div class="nk-block-head nk-block-head-lg">
                                                <div class="nk-block-between">
                                                    <div class="nk-block-head-content">
                                                        <h4 class="nk-block-title">Formularios Offline no Tablet</h4>
                                                        <div class="nk-block-des">
                                                            <p>Histórico de todos os formulários que foram salvos no
                                                                tablete até
                                                                presente momento (para questão de verificação).
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="nk-block card card-bordered">
                                                <table class="table table-ulogs">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th class="tb-col-time">
                                                                <span class="overline-title">ID</span>
                                                            </th>
                                                            <th class="tb-col-time">
                                                                <span class="overline-title">Email</span>
                                                            </th>
                                                            <th class="tb-col-time">
                                                                <span class="overline-title">Data Criação</span>
                                                            </th>
                                                            <th class="tb-col-time">
                                                                <span class="overline-title">Ver</span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let item of mdcOfflineSync | paginate: { id: 'offline-table-pagination', itemsPerPage: itemsPerPage3, currentPage: p3 }; let i = index">
                                                            <td class="tb-col-time">
                                                                <span class="sub-text">MdC_{{ item.id }}</span>
                                                            </td>
                                                            <td class="tb-col-time">
                                                                <span class="sub-text">{{ item.email }}</span>
                                                            </td>
                                                            <td class="tb-col-time">
                                                                <span class="sub-text">
                                                                    {{ item.created_at| date: 'dd-MM-yyyy HH:mm' }}
                                                                </span>
                                                            </td>
                                                            <td class="tb-col-time">
                                                                <a class="pointer" (click)="verDetalhesJson(item.id)">
                                                                    <em class="icon ni ni-eye-fill"></em>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="mdcOfflineSync.length === 0">
                                                            <td class="tb-col" colspan="4">
                                                                <p class="center">Sem dados no momento</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <pagination-controls id="offline-table-pagination"
                                                    class="mt-3 pagination" [previousLabel]="''" [nextLabel]="''"
                                                    [responsive]="true" (pageChange)="p3 = $event"
                                                    [autoHide]="false"></pagination-controls>
                                            </div>
                                            <div *ngIf="mdcOfflineSync.length > 0"
                                                class="between-center flex-wrap flex-md-nowrap g-3 mt-3">
                                                <div class="nk-block-text">
                                                </div>
                                                <button [disabled]="isSyncingAll" (click)="onSyncAll()" type="button"
                                                    class="btn btn-success">
                                                    <span *ngIf="!isSyncingAll">Enviar todos</span>
                                                    <span *ngIf="isSyncingAll">
                                                        Enviando...
                                                        <em class="spinner-border spinner-border-sm" role="status"
                                                            aria-hidden="true"></em>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>